import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { VolunteerMeta, TabPanel } from '../../index';
import Spinner from '../../../assets/spinner.svg';
import utils from '../../../utils';
import { useSimpleTabs } from '../../../hooks';

const SimpleTabs = (props) => {
  const { searchValue, setPagesTotal, pageNumber } = props;
  const {
    classes,
    isLoading,
    tabIndex,
    volunteersTotal,
    volunteers,
    memoizedAllVolunteers,
    a11yProps,
    handleChange,
  } = useSimpleTabs(searchValue, setPagesTotal, pageNumber);

  return (
    <Box className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab
            key={utils.addID()}
            label={`ВСЕ (${tabIndex === 0 ? volunteersTotal : 'Н/Д'})`}
            {...a11yProps(0)}
          />
          <Tab
            key={utils.addID()}
            label={`Нераспределённые (${
              tabIndex === 1 ? volunteersTotal : 'Н/Д'
            })`}
            {...a11yProps(1)}
          />
          <Tab
            key={utils.addID()}
            label={`Распределённые (${
              tabIndex === 2 ? volunteersTotal : 'Н/Д'
            })`}
            {...a11yProps(2)}
          />
          <Tab
            key={utils.addID()}
            label={`Совет ЦЗР (${tabIndex === 3 ? volunteersTotal : 'Н/Д'})`}
            {...a11yProps(3)}
          />
        </Tabs>
      </AppBar>
      {!isLoading ? (
        <>
          {[...new Array(5)].map((_, index) => (
            <TabPanel key={utils.addID()} value={tabIndex} index={index}>
              {volunteers.length > 0 ? (
                memoizedAllVolunteers
              ) : (
                <Box key={utils.addID()} mb={2}>
                  <VolunteerMeta
                    key={utils.addID()}
                    item={'Данные не найдены.'}
                  />
                </Box>
              )}
            </TabPanel>
          ))}
        </>
      ) : (
        <div
          key={utils.addID()}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <img key={utils.addID()} alt="Иконка загрузки" src={Spinner} />
        </div>
      )}
    </Box>
  );
};

export default SimpleTabs;
